import * as Sentry from '@sentry/react'

import { clientEnv } from '@/env.client'

// Non-critical app sharing the 'evnttz' Sentry project's quota — error
// monitoring only, no tracing, no Session Replay.
Sentry.init({
  dsn: clientEnv.NEXT_PUBLIC_EVNTTZ_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: Boolean(clientEnv.NEXT_PUBLIC_EVNTTZ_SENTRY_DSN) && import.meta.env.PROD,

  initialScope: scope => {
    scope.setTag('app', 'gamification')
    scope.setTag('tier', 'non-critical')
    return scope
  },

  tracesSampleRate: 0
})
